<template>
	<v-card
		outlined
	>
		<v-card-title
			class="text_primary"
		>
			{{ page_title }}

			<v-spacer></v-spacer>

		</v-card-title>

		<v-divider></v-divider>
		<v-row class="mt-1 mb-1 pr-3">
			<v-col
				cols="12"
				lg="12"
				md="12"
				xs="12"
			>  
				<v-card-text
					class="d-flex align-center justify-end pa-0"
				>
					<p class="mb-0 pb-0 mr-3">顯示</p>
					<v-select
						style="max-width:7em;"
						outlined
						return-object
						@change="chagePerPage(selected_per_page)"
						v-model="selected_per_page"
						:items="per_page_items"
						item-value="value"
						item-text="name"
						hide-details
						dense
					>
					</v-select>
				</v-card-text>
			</v-col>
		</v-row>
		<v-divider></v-divider>

		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="datas"
			:items-per-page="selected_per_page.value"
		>
          <template v-slot:[`item.task_name`] = "{item}">
            <span>{{display_task_name[item.task_name] ? display_task_name[item.task_name]: ''}}</span>
          </template>


          <template v-slot:[`item.created_at`] = "{item}">
            <span>
                {{ item.created_at ? $utils.displayISOString(item.created_at) : item.created_at}}
            </span>
          </template>

          <template v-slot:[`item.finish_at`] = "{item}">
            <span>
                {{ item.finish_at ? $utils.displayISOString(item.finish_at) : item.finish_at}}
            </span>
          </template>

          <template v-slot:[`item.actions`] = "{item}">

            <v-btn
              class="text_default btn_default btn_default_bg_linear"
              outlined
              @click="downloadReport(item) "
            >
              下載
            </v-btn> 

            <!-- <v-btn
              class="btn_action btn_action_bg_linear mr-3"
              outlined
              @click="edit(item)"
            >
              編輯設定
            </v-btn> 

            <v-btn
			  
              class="btn-danger white--text"
              outlined
              @click="del(item)"
            >
              刪除
            </v-btn>        -->
          </template>
		</v-data-table>

		<div class="text-center mt-5">
			<Pagination
				v-if="page_setting.is_show"
				:setting="page_setting"
			/>
		</div>
	</v-card>
</template>
<script>
import Pagination from '@/components/Utils/Pagination.vue'
import {
    apiGetUserBatchList,
    apiDownloadBatch
} from '@/api/user.js'
import {
    apiGetInvoiceCollectorPrivate,
} from '@/api/urlview.js'
export default {
    name: 'BatchList',
    components: {
        Pagination
    },
    data: function() {
        return {	
            page_title: "作業進度",
            display_task_name: {
                outputInvoiceExcelData: '匯出發票資料'
            },
            display_file_name: {
                outputInvoiceExcelData: '發票資料'
            },
            is_loading: false,	
            datas: [],
            headers: [      
                {
                    text: '執行項目',
                    sortable: false,
                    value: 'task_name',
                },
                {
                    text: '開始時間',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: '結束時間',
                    sortable: false,
                    value: 'finish_at',
                },
                { 
                    text: '', 
                    sortable: false,
                    value: 'actions',
                    align: 'right',
                }, 					             
            ],
            page_setting: {
                is_show: false,
                selected_page: 1,
                total_page: 10,
                total_visible: 5,
            },
            selected_per_page: {
                name: "48筆",
                value: 48, 
            },
            per_page_items: [
                {
                    name: "10筆",
                    value: 10, 
                },
                {
                    name: "24筆",
                    value: 24, 
                },
                {
                    name: "48筆",
                    value: 48, 
                },
                {
                    name: "100筆",
                    value: 100, 
                },
            ],
        }
    },
    mounted: async function() {
        this.initData()
    },
    methods: {
        initData: async function(){
            // 先抓網址上的頁碼，沒有預設就帶1
            let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
            let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.selected_per_page.value

            if (isNaN(limit)) {
                limit = 10
            }

            if (isNaN(page_idx)) {
                page_idx = 1
            }
            let data = null

            try {
                let result = await apiGetUserBatchList(
                    this.$route.params.org_id, this.$route.params.container_id,
                    page_idx, limit
                )
                data = result
                console.log('result', result)
            } catch (error) {
                console.log('error',error)
                this.$root.vtoast.show({
                    message: `取得資料失敗，原因: ${error}`,
                })
                if (error.includes('401') || error.includes('403')) {
                    this.$router.replace(`/${this.$route.params.org_id}/401`)
                }
            }
            console.log('回應', data)
            if (data === null) {
                return
            }

            this.page_setting = {
                is_show: true,
                selected_page: page_idx,
                total_page: data.data.totalPages,
            }
            this.datas = data.data.content
            
            console.log('datas',this.datas)

        },
        chagePerPage: async function(selected_per_page){
            let query = this.$route.query;
            let tmp_query = {...query, limit: selected_per_page.value, page: 1};
            console.log(tmp_query)
            try {
                await this.$router.push({ path: this.$route.path, query: tmp_query})
            } catch (err) {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            }
            await this.initData()
        },
        async downloadReport(item){
            let file_name = ''
            if (this.display_file_name[item.task_name]) {
                file_name = this.display_file_name[item.task_name]
            }
            else {
                file_name = item.task_name
            }
            let name = ''
            if (item.task_name === "outputInvoiceExcelData") {
                try {
                    let result = await apiGetInvoiceCollectorPrivate(
                        this.$route.params.org_id, item.request.invoice_collector_id
                    )
                    console.log('result', result)
                    name = result.data.invoice_collector.ict_name
                } catch (error) {
                    name = item.request.invoice_collector_id
                    console.log('error', error)
                }
            }

            try {
                let result = await apiDownloadBatch(
                    this.$route.params.org_id, item.id
                )
                console.log('d_result', result)
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(result);
                link.download = `${file_name}_${name}.xlsx`;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);


            } catch (error) {
                console.log('error', error)
            }
        }
    },	
    computed: {
    }     
}
</script>
<style scoped>
</style>